import { Modal }    from 'antd';
import { Icon }                  from 'View/Common';
import { Fragment, useCallback } from 'react';
import { useDispatch }           from 'react-redux';
import { UnknownAction } from 'redux';

type TProps = {
  record: any,
  deleteAction:  ({ id }: { id: string }) => UnknownAction,
}

export const useOnDelete = () => {
  const dispatch = useDispatch();

  return useCallback(({ record, deleteAction }: TProps) => {
    Modal.confirm({
      title: 'Datensatz unwiderruflich löschen!',
      icon: <Icon type="warning"/>,
      content: <Fragment>Möchten Sie diesen Eintrag <br/><strong>{record.name}</strong><br/> wirklich unwiderruflich löschen, alle Abhängigkeiten gehen dabei
        verloren?</Fragment>,
      okText: 'Datensatz löschen',
      cancelText: 'Abbrechen',
      onOk: () => {
        dispatch(deleteAction({ id: record.id }));
      }
    });
  }, []);
};
